module.exports = __webpack_public_path__ + "media/images/cover-497d6df4a62920c30e7cfbf4d513a14c.jpg";